<template>
  <div v-if="visible" class="dpMask" @click.self="close">
    <div class="dpCard">
      <button type="button" class="dpClose" @click="close">×</button>
      <div class="dpBrand">
        <p class="dpName">{{ siteName }}</p>
        <p class="dpSub">官方永久网址</p>
      </div>
      <div class="dpBody">
        <p class="dpTip">为了防止网站打不开，请保存我们的官方网址，以免找不到回家的路！</p>
        <div class="dpHead">
          <span>官方永久网址</span>
          <button type="button" @click="copyAll">复制全部</button>
        </div>
        <div class="dpRow" v-for="(d, i) in domains" :key="i">
          <div>
            <p>{{ d.label }}</p>
            <b>{{ d.url }}</b>
          </div>
          <button type="button" @click="copyOne(d.url)">复制</button>
        </div>
        <div class="dpActs">
          <button type="button" class="ghost" @click="saveImage">保存图片</button>
          <button type="button" class="solid" @click="saveTxt">保存到记事本</button>
        </div>
      </div>
    </div>
    <div class="dpPoster" v-if="posterUrl" @click="posterUrl = ''">
      <img :src="posterUrl" alt="" />
      <p>长按上方图片，保存到相册</p>
    </div>
  </div>
</template>
<script>
import { officialDomains, officialText, copyPlain, downloadPlain, drawOfficialPoster } from './officialDomains';

var SEEN = 'official_url_prompt';

export default {
  name: 'domainPrompt',
  data() {
    return { visible: false, posterUrl: '', domains: officialDomains };
  },
  computed: {
    siteName() {
      return (this.$store.state.appInfo && this.$store.state.appInfo.title) || '澳门·新葡京';
    },
  },
  mounted() {
    this.maybeShow();
  },
  watch: {
    '$store.state.token': function (val) {
      if (!val) {
        this.visible = false;
        this.posterUrl = '';
        return;
      }
      this.maybeShow();
    },
    '$route.path': function () {
      this.maybeShow();
    },
  },
  methods: {
    maybeShow() {
      if (this.visible) return;
      if (!this.$store.state.token) return;
      var path = this.$route.path;
      if (path === '/gamePage' || path === '/login' || path === '/register') return;
      try {
        if (sessionStorage.getItem(SEEN)) return;
        sessionStorage.setItem(SEEN, '1');
      } catch (e) {}
      this.visible = true;
    },
    close() {
      this.visible = false;
      this.posterUrl = '';
    },
    toast(ok, msg) {
      if (this.$parent && this.$parent.showTost) this.$parent.showTost(ok ? 1 : 0, msg);
    },
    copyOne(url) {
      var ok = copyPlain(url);
      this.toast(ok, ok ? '已复制：' + url : '复制失败，请长按手动复制');
    },
    copyAll() {
      var text = this.domains.map(function (d) { return d.url; }).join('\n');
      var ok = copyPlain(text);
      this.toast(ok, ok ? '已复制全部网址' : '复制失败，请长按手动复制');
    },
    saveTxt() {
      var text = officialText(this.siteName, this.domains);
      if (downloadPlain(this.siteName + '-官方网址.txt', text)) {
        this.toast(1, '已生成网址文件');
      } else {
        this.toast(copyPlain(text), '已复制，可粘贴到记事本保存');
      }
    },
    saveImage() {
      this.posterUrl = drawOfficialPoster(this.siteName, this.domains);
    },
  },
};
</script>
<style lang="scss" scoped>
.dpMask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 12000;
  background: rgba(20, 8, 12, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  box-sizing: border-box;
}
.dpCard {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  position: relative;
}
.dpClose {
  position: absolute;
  right: 10px;
  top: 8px;
  width: 32px;
  height: 32px;
  border: 0;
  background: transparent;
  color: #f3e6d4;
  font-size: 26px;
  line-height: 32px;
}
.dpBrand {
  background: linear-gradient(160deg, #5c1c34, #2a1018);
  padding: 22px 18px 16px;
  text-align: center;
  .dpName {
    margin: 0;
    color: #f4e2bc;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 1px;
  }
  .dpSub {
    margin: 6px 0 0;
    color: rgba(255, 255, 255, 0.82);
    font-size: 13px;
  }
}
.dpBody {
  padding: 14px 14px 16px;
}
.dpTip {
  margin: 0 0 12px;
  padding: 10px 12px;
  background: #e8f7ee;
  color: #1f8a52;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.5;
}
.dpHead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  span {
    font-weight: 700;
    color: #1c1416;
  }
  button {
    border: 0;
    background: transparent;
    color: #8a2942;
    font-size: 13px;
  }
}
.dpRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f7f4f2;
  border-radius: 12px;
  padding: 10px 12px;
  margin-bottom: 8px;
  p {
    margin: 0;
    color: #9a8b86;
    font-size: 12px;
  }
  b {
    display: block;
    margin-top: 2px;
    color: #1c1416;
    font-size: 16px;
  }
  button {
    border: 0;
    background: #fff;
    color: #8a2942;
    border-radius: 8px;
    height: 32px;
    padding: 0 10px;
  }
}
.dpActs {
  display: flex;
  gap: 10px;
  margin-top: 12px;
  button {
    flex: 1;
    height: 42px;
    border-radius: 12px;
    font-size: 15px;
  }
  .ghost {
    background: #fff;
    color: #8a2942;
    border: 1px solid #8a2942;
  }
  .solid {
    background: #6e2438;
    color: #fff;
    border: 0;
  }
}
.dpPoster {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  background: rgba(0, 0, 0, 0.72);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  img {
    max-width: 86vw;
    max-height: 70vh;
    border-radius: 12px;
  }
  p {
    color: #fff;
    margin-top: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/domainPrompt.vue